import type { ProviderProps } from '@reactour/tour';
import { SetupTourNextButton, SetupTourPreviousButton } from './SetupTourNavigationButtons';

export const renderSetupTourNextButton: NonNullable<ProviderProps['nextButton']> = (props) => (
  <SetupTourNextButton {...props} />
);

export const renderSetupTourPreviousButton: NonNullable<ProviderProps['prevButton']> = (props) => (
  <SetupTourPreviousButton {...props} />
);
